import {gatewayInstance} from "../axiosInstance";
import {SERVICE_ENDPOINT} from "../const";


export const searchAlerts = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/default-alerts/search`,
            data,
        );
        return response.data;
    } catch (e) {
        console.error();
    }
};

export const addAlertData = async (data) => {
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/default-alerts`,
        data,
    );
    return response.data;
};

export const updateAlertData = async (data) => {
    const response = await gatewayInstance.put(
        `${SERVICE_ENDPOINT.TRANSPORT}/default-alerts`,
        data,
    );
    return response.data;
};

export const getAlertDataById = async (id) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/default-alerts/${id}`,
        );
        return response.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
};